import(/* webpackMode: "eager" */ "/cg-test-project/components/site-header.tsx")